import { TEAM_NEW_USER_LOGIN } from "../actions";


export const setNewUserEmailFromNotification = (email) => {
    return {
        type: TEAM_NEW_USER_LOGIN,
        payload: { email }
    }
}